var _excluded = ["logger", "progress"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var createJob = require('./createJob');

var _require = require('./utils/log'),
    log = _require.log;

var getId = require('./utils/getId');

var parseProgress = require('./utils/parseProgress');

var resolvePaths = require('./utils/resolvePaths');

var getTransferables = require('./utils/getTransferables');

var _require2 = require('./worker/node'),
    defaultOptions = _require2.defaultOptions,
    spawnWorker = _require2.spawnWorker,
    onMessage = _require2.onMessage,
    fetchFile = _require2.fetchFile;

var workerCounter = 0;

module.exports = function () {
  var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var id = getId('Worker', workerCounter);

  var _resolvePaths = resolvePaths(_objectSpread(_objectSpread({}, defaultOptions), _options)),
      logger = _resolvePaths.logger,
      progress = _resolvePaths.progress,
      options = _objectWithoutProperties(_resolvePaths, _excluded);

  var resolves = {};
  var rejects = {};
  var worker = spawnWorker(options);
  workerCounter += 1;

  var setResolve = function setResolve(action, res) {
    resolves[action] = res;
  };

  var setReject = function setReject(action, rej) {
    rejects[action] = rej;
  };

  var startJob = function startJob(_ref) {
    var jobId = _ref.id,
        action = _ref.action,
        payload = _ref.payload;
    return new Promise(function (resolve, reject) {
      var packet = {
        workerId: id,
        jobId: jobId,
        action: action,
        payload: payload
      };
      log("[".concat(id, "]: Start ").concat(jobId, ", action=").concat(action));
      setResolve(action, resolve);
      setReject(action, reject);
      /*
       * By using Transferable in postMessage, we are able
       * to send large files to worker
       * @ref: https://github.com/ffmpegjs/ffmpeg.js/issues/8#issuecomment-572230128
       */

      worker.postMessage(packet, getTransferables(packet));
    });
  };

  var load = function load(jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'load',
      payload: {
        options: options
      }
    }));
  };

  var write = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path, data, jobId) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = startJob;
              _context.t1 = createJob;
              _context.t2 = jobId;
              _context.t3 = path;
              _context.next = 6;
              return fetchFile(data);

            case 6:
              _context.t4 = _context.sent;
              _context.t5 = [_context.t3, _context.t4];
              _context.t6 = {
                method: 'writeFile',
                args: _context.t5
              };
              _context.t7 = {
                id: _context.t2,
                action: 'FS',
                payload: _context.t6
              };
              _context.t8 = (0, _context.t1)(_context.t7);
              return _context.abrupt("return", (0, _context.t0)(_context.t8));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function write(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var writeText = function writeText(path, text, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: 'writeFile',
        args: [path, text]
      }
    }));
  };

  var read = function read(path, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: 'readFile',
        args: [path]
      }
    }));
  };

  var remove = function remove(path, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: 'unlink',
        args: [path]
      }
    }));
  };

  var run = function run(args, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'run',
      payload: {
        args: args
      }
    }));
  };

  var ls = function ls(path, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: 'readdir',
        args: [path]
      }
    }));
  };

  var transcode = function transcode(input, output) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var jobId = arguments.length > 3 ? arguments[3] : undefined;
    return run("-i ".concat(input, " ").concat(opts, " ").concat(output), jobId);
  };

  var trim = function trim(input, output, from, to) {
    var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var jobId = arguments.length > 5 ? arguments[5] : undefined;
    return run("-i ".concat(input, " -ss ").concat(from, " -to ").concat(to, " ").concat(opts, " ").concat(output), jobId);
  };

  var concatDemuxer = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(input, output) {
      var opts,
          jobId,
          text,
          _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : '';
              jobId = _args2.length > 3 ? _args2[3] : undefined;
              text = input.reduce(function (acc, path) {
                return "".concat(acc, "\nfile ").concat(path);
              }, '');
              _context2.next = 5;
              return writeText('concat_list.txt', text);

            case 5:
              return _context2.abrupt("return", run("-f concat -safe 0 -i concat_list.txt ".concat(opts, " ").concat(output), jobId));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function concatDemuxer(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var terminate = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(jobId) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(worker !== null)) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return startJob(createJob({
                id: jobId,
                action: 'terminate'
              }));

            case 3:
              worker.terminate();
              worker = null;

            case 5:
              return _context3.abrupt("return", Promise.resolve());

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function terminate(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  onMessage(worker, function (_ref5) {
    var workerId = _ref5.workerId,
        jobId = _ref5.jobId,
        action = _ref5.action,
        status = _ref5.status,
        payload = _ref5.payload;

    if (status === 'resolve') {
      var message = payload.message,
          data = payload.data;
      log("[".concat(workerId, "]: Complete ").concat(jobId));
      resolves[action]({
        workerId: workerId,
        jobId: jobId,
        message: message,
        data: data
      });
    } else if (status === 'reject') {
      rejects[action](payload);
      throw Error(payload);
    } else if (status === 'progress') {
      parseProgress(payload, progress);
      logger(payload);
    }
  });
  return {
    id: id,
    worker: worker,
    setResolve: setResolve,
    setReject: setReject,
    load: load,
    write: write,
    writeText: writeText,
    read: read,
    remove: remove,
    ls: ls,
    run: run,
    transcode: transcode,
    trim: trim,
    concatDemuxer: concatDemuxer,
    terminate: terminate
  };
};